import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import DashboardContent from "../../components/Pages/Dashboard";

const { displayName } = config;

export default function Dashboard(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Dashboard`;
  }, []);

  return (
    <Layout>
      <DashboardContent />
    </Layout>
  );
}
